export const MAX_TIERS_LENGTH = 6
